import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faSearch,
  faFilterList,
} from "@fortawesome/pro-regular-svg-icons";
/* import useExporter from "../../hooks/useExporter"; */
import { Link, useParams } from "react-router-dom";
import HeaderBar from "../../components/HeaderBar";
import Sidebar from "../../components/Sidebar";
import { getBillingHistoryByAgreement } from "../../api/BillingGroups";
import { useAuth } from "../../providers/AuthContext";
import InputField from "../../components/InputField";
import ConfirmationModal from "../../components/ConfirmationModal";
import LoadingTablePage from "../LoadingTablePage";
import Breadcrumbs from "../../components/Breadcrumbs";
import TableView from "../../components/TableView";
import priceFormatter from "../../helpers/PriceFormatter";

const HistoryBillingPage = () => {
  /* const { handleExport } = useExporter(); */

  const { agreementPublicId } = useParams();
  const { getAccessToken } = useAuth();
  const [selectedRows, setSelectedRows] = useState([]);
  const [historyBilling, setHistoryBilling] = useState([]);
  const [filteredHistoryBilling, setFilteredHistoryBilling] = useState([]);
  const [selectedHistoryBilling, setSelectedHistoryBilling] = useState([]);

  const [search, setSearch] = useState("");
  const [historyBillingLoaded, setHistoryBillingLoaded] = useState(false);
  const [confirmState, setConfirmState] = useState({
    isOpen: false,
    title: "",
    confirm: () => {},
  });

  /*   const handleOpenModal = () => {
    if (selectedHistoryBilling.length === 0) {
      toast.error("No historyBilling selected");
      return;
    }
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedBillingGroup(null);
  }; */

  /* const handleChangeBillingGroup = async () => {
    if (!selectedBillingGroup || selectedHistoryBilling.length === 0) {
      toast.error("Please select historyBillings and a billing group.");
      return;
    }

    try {
      const accessToken = await getAccessToken();

      // Update each historyBilling one by one
      await Promise.all(
        selectedHistoryBillings.map(async (historyBillingPublicId) => {
          return updateBillingGroupOnHistoryBilling(
            selectedBillingGroup,
            historyBillingPublicId,
            accessToken
          );
        })
      );

      toast.success("Billing group updated successfully for selected historyBillings!", {
        iconTheme: {
          primary: "#4CAF50", 
          secondary: "#DFF2BF",
        }
      });

      handleGetHistoryBillings(); // Refresh historyBillings after update
      setSelectedHistoryBillings([]); // Clear selection
      setIsModalOpen(false); // Close modal
    } catch (error) {
      console.error("Failed to update billing group:", error);
      toast.error("Failed to update billing group for selected historyBillings.");
    }
  }; */

  useEffect(() => {
    handleGetHistoryBilling(); // Initial fetch

    /*     const handleHistoryBillingUpdate = () => {
      handleGetHistoryBilling();
    };

    window.addEventListener("historyBillingUpdated", handleHistoryBillingUpdate);

    return () => {
      window.removeEventListener("historyBillingUpdated", handleHistoryBillingUpdate);
    }; */
  }, [agreementPublicId]);

  /*   useEffect(() => {
    const applyFilterAndSort = () => {
      let filtered = historyBillings;

      if (search) {
        const searchLower = search.toLowerCase();
        filtered = historyBilling.filter(
          (historyBilling) =>
            historyBilling.historyBillingPublicId?.toLowerCase().includes(searchLower) ||
            historyBilling.displayName?.toLowerCase().includes(searchLower) ||
            historyBilling.historyBillingPrincipalName?.toLowerCase().includes(searchLower) ||
            historyBilling.accountType?.toLowerCase().includes(searchLower) ||
            historyBilling.billingGroup?.toLowerCase().includes(searchLower)
        );
      }

      if (sortColumn) {
        filtered = [...filtered].sort((a, b) => {
          const aValue = (a[sortColumn] || "").toString().toLowerCase();
          const bValue = (b[sortColumn] || "").toString().toLowerCase();
          return sortOrder === "asc"
            ? aValue.localeCompare(bValue)
            : bValue.localeCompare(aValue);
        });
      }

      setFilteredHistoryBillings(filtered);
    };

    applyFilterAndSort();
  }, [search, historyBillings, sortColumn, sortOrder]); */

  const handleGetHistoryBilling = async () => {
    try {
      const accessToken = await getAccessToken();
      const newHistoryBilling = await getBillingHistoryByAgreement(
        agreementPublicId,
        accessToken
      );

      newHistoryBilling.forEach(item => {
        item.total = priceFormatter(item.total);
        item.date = item.date?.split("T")[0];
        item.fromDate = item.fromDate?.split("T")[0];
        item.toDate = item.toDate?.split("T")[0];
      });

      setHistoryBilling(newHistoryBilling);
      setFilteredHistoryBilling(newHistoryBilling);
      setHistoryBillingLoaded(true);
    } catch (error) {
      console.error(error);
      setHistoryBillingLoaded(true);
    }
  };

  /*   const handleDeleteHistoryBilling = async (historyBillingPublicId) => {
    const toastId = toast.loading("Deleting historyBilling...");
    try {
      const accessToken = await getAccessToken();
      await deleteHistoryBilling(historyBillingPublicId, accessToken);
      const newHistoryBillings = await getHistoryBillingsByTenant(accessToken);
      setHistoryBillings(newHistoryBillings);
      toast.success("HistoryBilling deleted", { id: toastId });
    } catch (error) {
      toast.error("Failed to delete historyBilling", { id: toastId });
      console.error(error);
    }
  }; */

  return (
    <>
      <HeaderBar />
      <div className="flex flex-col">
        <div className="flex flex-row">
          <Sidebar />
          <main className="page">
            <div className="absolute w-full pointer-events-none">
              <LoadingTablePage
                title={"HistoryBilling"}
                loading={!historyBillingLoaded}
              />
            </div>

            <div
              className={`${
                !historyBillingLoaded ? "loading" : ""
              } page-content`}
            >
              <Breadcrumbs />
              <div className="flex justify-between items-center">
                <h2 className="text-2xl text-black font-bold pb-2">
                  Billing history
                </h2>

                <Link
                  to="/historyBilling/createhistoryBilling"
                  className="btn-primary hidden"
                >
                  {" "}
                  {/* DOLD */}
                  <FontAwesomeIcon
                    icon={faPlus}
                    className="mr-2 text-lg"
                  />{" "}
                  Create historyBilling
                </Link>
              </div>
              <div className="rounded-md shadow-md border w-full p-4">
                <div className="flex mb-2 gap-4 justify-between">
                  <button
                    className="btn-outline-primary-small hidden"
                    /*                     onClick={handleOpenModal}
                     */ hidden={selectedHistoryBilling.length === 0}
                  >
                    Update billing group
                  </button>
                  <div className="flex">
                    <button className="btn-outline-primary icon hidden">
                      {" "}
                      {/* DOLD */}
                      <FontAwesomeIcon
                        icon={faFilterList}
                        className="mr-2 text-lg"
                      />
                      Filter
                    </button>
                  </div>
                  <div className="flex items-center">
                    <InputField
                      iconLeft={false}
                      icon={faSearch}
                      placeholder={"Name, Manager, Email "}
                      value={search}
                      onChange={(v) => {
                        setSearch(v.target.value);
                      }}
                    />
                    <button className="btn-outline-primary ml-4 hidden">
                      {" "}
                      {/* DOLD */}
                      Export to excel
                    </button>
                  </div>
                </div>

                <div className="overflow-x-auto pb-[250px] mb-[-250px]">
                  <TableView
                    data={filteredHistoryBilling}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                    noCheckbox={true}
                    noDelete={true}
                    editLabel="Details"
                    columns={[
                      { key: "createdDateTimeUTC", label: "Created date" },
                      { key: "fromDate", label: "From date" },
                      { key: "toDate", label: "To date" },
                      { key: "billingGroupName", label: "Billing group name" },

                      { key: "total", label: "Total price" },
                      {
                        key: "historyPublicId",
                        label: "Billing ID",
                      }
                    ]}
                    primaryKey="historyPublicId"
                    basePath={`/${agreementPublicId}/history-billing`}
                  />
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
      {/*       <Modal isOpen={isModalOpen} setIsOpen={setIsModalOpen}>
        <div className="bg-white p-6 rounded-lg w-[400px]">
          <h2 className="text-xl font-semibold mb-4">Change Billing Group</h2>

          <Dropdown
            label="Select Billing Group"
            options={billingGroups.map((group) => group.name)} // Assuming `group.name` is the display value
            value={selectedBillingGroup}
            onSelect={(value) => setSelectedBillingGroup(value)}
          />

          <div className="flex justify-end mt-4 gap-4">
            <button
              className="btn-outline-primary"
              onClick={handleCloseModal}
            >
              Cancel
            </button>
            <button className="btn-primary" onClick={handleChangeBillingGroup}>
              Confirm
            </button>
          </div>
        </div>
      </Modal> */}

      <ConfirmationModal
        isOpen={confirmState.isOpen}
        title={confirmState.title}
        onClose={() => setConfirmState((s) => ({ ...s, isOpen: false }))}
        onConfirm={() => {
          setConfirmState((s) => ({ ...s, isOpen: false }));
          confirmState.confirm();
        }}
      />
    </>
  );
};

export default HistoryBillingPage;
